module.exports = __webpack_public_path__ + "media/images/logo-75ce5ec6aee18837fc1fca89d4aa8eb5.svg";